export const schemaKey = Symbol('schema')
export const valuesKey = Symbol('values')
export const errorsKey = Symbol('errors')
export const fieldNameKey = Symbol('fieldName')
